import * as React from 'react';

function SvgPaste(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M24 13.71v9A1.3 1.3 0 0122.71 24H9.85a1.25 1.25 0 01-.92-.38 1.23 1.23 0 01-.37-.91v-2.14H1.28a1.25 1.25 0 01-.91-.38 1.23 1.23 0 01-.37-.91v-18A1.26 1.26 0 011.28 0h14.57a1.25 1.25 0 01.92.37 1.29 1.29 0 01.37.91v4.4a2.34 2.34 0 01.48.37l5.47 5.47a3 3 0 01.64 1 3.07 3.07 0 01.27 1.19zM13.71 3v-.86a.38.38 0 00-.13-.3.38.38 0 00-.3-.13H3.85a.43.43 0 00-.42.43V3a.44.44 0 00.12.3.45.45 0 00.3.13h9.43a.42.42 0 00.3-.13.41.41 0 00.13-.3zm-3.43 19.28h12v-8.57h-5.57a1.23 1.23 0 01-.91-.37 1.25 1.25 0 01-.37-.91V6.85h-5.15zM17.14 12h4l-4-4z" />
    </svg>
  );
}

const MemoSvgPaste = React.memo(SvgPaste);
export default MemoSvgPaste;
